import type { ChallengeModifierId, CatClassId } from '@cradle7/shared';

/**
 * If a daily-challenge modifier locks the cat class, return the forced class id.
 * Otherwise return null — caller keeps the player's chosen class.
 *
 * Today only `class_lock_engineer` exists; add new entries here as more
 * `class_lock_*` modifiers ship.
 */
export function forcedClassForChallenge(modifierId: ChallengeModifierId): CatClassId | null {
  if (modifierId === 'class_lock_engineer') return 'engineer';
  return null;
}
